import IApi from '@/interfaces/IApi';

const auth: IApi = {"id":1,"displayName":"Authentication API","baseUrl":"https://crm-auth-api.awd-euw.bookingonline.co.uk/api/"};
const contentScrape: IApi = {"id":2,"displayName":"Content Scraper API","baseUrl":"https://crm-api-content-creation.awd-euw.bookingonline.co.uk/"};

const apiList = {
  auth, contentScrape,
};

export { auth, contentScrape };

export default apiList;
